import React, { useEffect, useState } from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { Shield, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";

export default function MasterInsurance() {
  const [count, setCount] = useState(null);
  const [seeding, setSeeding] = useState(0);
  const load = () => api.get("/master/insurance").then((r) => setCount((r.data || []).length)).catch(() => {});
  useEffect(() => { load(); }, []);

  const seedDefaults = async () => {
    setSeeding(1);
    try {
      const r = await api.post("/master/insurance/seed-defaults");
      if (r.data.added > 0) toast.success(`${r.data.added} seguradora(s) adicionada(s) — total ${r.data.total}`);
      else toast.info("Todas as 21 seguradoras padrão já estão cadastradas");
      load();
      // trigger MasterDataPage reload
      setTimeout(() => window.location.reload(), 400);
    } catch (e) { toast.error("Falha ao popular"); }
    setSeeding(0);
  };

  return (
    <div className="space-y-4">
      {count !== null && count < 21 && (
        <div className="rounded-xl border border-cyan-500/30 bg-cyan-500/5 p-4 flex items-center justify-between" data-testid="seed-banner">
          <div className="flex items-start gap-3">
            <Sparkles className="w-5 h-5 text-cyan-400 mt-0.5" />
            <div>
              <div className="text-sm font-medium text-slate-100">Popular com as 21 seguradoras padrão do mercado US</div>
              <div className="text-xs text-slate-400 mt-0.5">State Farm, GEICO, Progressive, Allstate, USAA, Liberty Mutual, Farmers, Nationwide, Travelers, e mais — incluindo regionais de MA (Arbella, Commerce).</div>
            </div>
          </div>
          <Button data-testid="seed-defaults-btn" onClick={seedDefaults} disabled={seeding} className="bg-cyan-600 hover:bg-cyan-500 shrink-0">
            <Sparkles className="w-4 h-4 mr-2" /> {seeding ? "Populando..." : "Popular Agora"}
          </Button>
        </div>
      )}

      <MasterDataPage
        title="Insurance Companies"
        subtitle="Carriers, adjusters, payment terms & policies"
        entity="insurance"
        testId="insurance"
        icon={Shield}
        detailRoute={(r) => `/master/insurance/${r.id}`}
        defaultForm={{
          name: "", short_code: "", phone: "", claims_email: "", submission_portal: "",
          payment_terms: "Net 30", requires_oem_proof: false, approves_dual_calibration: true,
          scan_policy: "always", oem_glass_policy: "case_by_case", typical_approval_days: 5, notes: "",
        }}
        fields={[
          { key: "name", label: "Carrier Name", required: true, span: 2 },
          { key: "short_code", label: "Short Code (PRG, SF, GEI)" },
          { key: "typical_approval_days", label: "Avg Approval Days", type: "number" },
          { key: "phone", label: "Claims Phone" },
          { key: "claims_email", label: "Claims Email", type: "email" },
          { key: "submission_portal", label: "Submission Portal URL", span: 2 },
          { key: "payment_terms", label: "Payment Terms", type: "select", options: ["Net 15", "Net 30", "Net 45", "Net 60", "On Receipt"] },
          { key: "scan_policy", label: "Scan Policy", type: "select", options: [{ value: "always", label: "Always pays" }, { value: "on_request", label: "On request" }, { value: "never", label: "Never pays" }] },
          { key: "oem_glass_policy", label: "OEM Glass Policy", type: "select", options: [{ value: "always", label: "Always allows" }, { value: "case_by_case", label: "Case by case" }, { value: "never", label: "AM glass only" }] },
          { key: "requires_oem_proof", label: "OEM Proof Required", type: "checkbox", checkboxLabel: "Always attach OEM documentation" },
          { key: "approves_dual_calibration", label: "Dual Calibration", type: "checkbox", checkboxLabel: "Carrier approves dual cal" },
          { key: "preferred_documentation", label: "Preferred Documentation", type: "textarea", span: 2 },
          { key: "notes", label: "Notes", type: "textarea", span: 2 },
        ]}
        columns={[
          { key: "name", label: "Carrier" },
          { key: "short_code", label: "Code" },
          { key: "claims_email", label: "Claims Email" },
          { key: "scan_policy", label: "Scan Policy" },
          { key: "approval_rate", label: "Approval", render: (r) => r.approval_rate != null ? `${r.approval_rate}%` : "—" },
          { key: "payment_terms", label: "Terms" },
        ]}
      />
    </div>
  );
}
